/**
 * Shared visual theme for the employer/recruiter side of Resmo.
 *
 * The candidate-side keeps its cream/orange character. Employer surfaces
 * (Discover, Candidates Store, Shortlist) use a sophisticated midnight-blue
 * gallery aesthetic — warm accent lights + fine grain + glassy header —
 * because recruiters spend hours reading résumés and the darker canvas
 * cuts eye fatigue while making candidate cards feel like exhibits.
 *
 * Keeping the tokens in one place so future employer pages can drop the
 * same look in a single import.
 */
export const NAVY    = "#0F1B2D";
export const ORANGE  = "#FF6A00";
export const MUSTARD = "#FFC145";
export const CREAM   = "#FFF2EC";

export const MIDNIGHT_BG = "#0A1730";

// Two soft radial spotlights + a tiny SVG noise grain. Fixed-attachment so
// the texture doesn't tile as the user scrolls (looks premium; costs
// nothing perf-wise since it's a small SVG data URL).
export const MIDNIGHT_BG_STYLE = {
  backgroundColor: MIDNIGHT_BG,
  backgroundImage:
    "radial-gradient(1200px 620px at 12% -10%, rgba(255,193,69,0.10), transparent 60%)," +
    "radial-gradient(900px 500px at 92% 108%, rgba(255,106,0,0.09), transparent 65%)," +
    "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='140' height='140' viewBox='0 0 140 140'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2' stitchTiles='stitch'/><feColorMatrix values='0 0 0 0 0.06  0 0 0 0 0.09  0 0 0 0 0.18  0 0 0 0.35 0'/></filter><rect width='100%25' height='100%25' filter='url(%23n)' opacity='0.6'/></svg>\")",
  backgroundAttachment: "fixed",
};

// Header band — glassy translucent navy over the midnight background.
export const GLASS_HEADER_STYLE = {
  background: "rgba(15, 27, 45, 0.72)",
  borderColor: "rgba(255, 193, 69, 0.28)",
  boxShadow: "0 1px 0 rgba(255,193,69,0.10), 0 12px 40px rgba(0,0,0,0.35)",
};

// Card shadow that reads well against dark backgrounds — hard mustard
// offset for depth + a soft black glow for lift.
export const CARD_DEEP_SHADOW = `4px 4px 0 0 ${MUSTARD}, 0 10px 30px rgba(0,0,0,0.35)`;
